import { render, staticRenderFns } from "./CuentaMedicaLayout.vue?vue&type=template&id=4089d6b2&scoped=true"
import script from "./CuentaMedicaLayout.vue?vue&type=script&lang=js"
export * from "./CuentaMedicaLayout.vue?vue&type=script&lang=js"
import style0 from "./CuentaMedicaLayout.vue?vue&type=style&index=0&id=4089d6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4089d6b2",
  null
  
)

export default component.exports